import { render } from "./CinemaSearch.vue?vue&type=template&id=2487f294&scoped=true"
import script from "./CinemaSearch.vue?vue&type=script&lang=js"
export * from "./CinemaSearch.vue?vue&type=script&lang=js"

import "./CinemaSearch.vue?vue&type=style&index=0&id=2487f294&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_ba160c7cc2f29ece52adbe34bb7fc3d0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487f294"]])

export default __exports__